import React, { useState } from "react"
import { MoveToDropdown } from "./MoveToDropdown"

/**
 * Bulk action bar that appears when files are selected.
 * Shows Move To, Mark Placed, Out of Scope, and Delete buttons.
 *
 * @param {Object} props
 * @param {number} props.selectedCount - Number of selected files
 * @param {Function} props.onMarkPlaced - Callback for Mark Placed action
 * @param {Function} props.onMarkOutOfScope - Callback for Out of Scope action
 * @param {Function} props.onDelete - Callback for Delete action
 * @param {boolean} [props.moveEnabled=false] - Whether to show Move To button (feature flag)
 * @param {Array} [props.buildings=[]] - Building items for MoveToDropdown
 * @param {Function} [props.onMoveToBuilding] - Callback with target building ID (or null for Inbox)
 * @returns {React.ReactElement|null} The bulk action bar or null if nothing selected
 */
export function BulkActionBar({
  selectedCount,
  onMarkPlaced,
  onMarkOutOfScope,
  onDelete,
  moveEnabled = false,
  buildings = [],
  onMoveToBuilding,
}) {
  const [showMoveDropdown, setShowMoveDropdown] = useState(false)

  if (selectedCount === 0) return null

  return (
    <div className="bulk-action-bar">
      {moveEnabled && (
        <div className="bulk-action-move-wrapper">
          <button
            className="bulk-action-btn"
            onClick={() => setShowMoveDropdown(prev => !prev)}
            type="button"
          >
            Move to...
          </button>
          {showMoveDropdown && (
            <MoveToDropdown
              buildings={buildings}
              onSelect={(buildingId) => {
                onMoveToBuilding(buildingId)
                setShowMoveDropdown(false)
              }}
              onClose={() => setShowMoveDropdown(false)}
            />
          )}
        </div>
      )}
      <button className="bulk-action-btn" onClick={onMarkPlaced} type="button">
        Mark Placed
      </button>
      <button className="bulk-action-btn" onClick={onMarkOutOfScope} type="button">
        Out of Scope
      </button>
      <button className="bulk-action-btn delete" onClick={onDelete} type="button">
        Delete
      </button>
    </div>
  )
}
